import { useState } from "react";
import { Navigate } from "react-router-dom";
import { LogIn } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatError } from "@/lib/api";
import { Brand } from "@/components/Brand";

export default function Login() {
  const { user, login } = useAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try { await login(username, password); } catch (err) { setError(formatError(err)); }
    setLoading(false);
  };

  return (
    <div className="page login-page">
      <header className="topbar"><Brand /></header>
      <form className="login-card" onSubmit={submit} data-testid="login-form">
        <p className="mono eyebrow">// acesso restrito</p>
        <h1 className="title-sm">Área do administrador</h1>
        <label className="field">
          <span>Usuário</span>
          <input value={username} onChange={(e) => setUsername(e.target.value)} autoComplete="username"
            autoCapitalize="none" required data-testid="login-username-input" />
        </label>
        <label className="field">
          <span>Senha</span>
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password" required data-testid="login-password-input" />
        </label>
        {error && <p className="form-error" data-testid="login-error">{error}</p>}
        <button className="btn-primary w-full" disabled={loading} data-testid="login-submit-button">
          <LogIn size={16} /> {loading ? "Entrando..." : "Entrar"}
        </button>
      </form>
    </div>
  );
}
